import React from 'react'
import DraggableModal from "../UI/DraggableModal";
import {Button, Modal} from "react-bootstrap";

interface AttentionSaveFormulaModalProps {
    show: boolean,
    onHide: () => void,
    onAccept: () => any
}

export default function AttentionSaveFormulaModal({show, onHide, onAccept}: AttentionSaveFormulaModalProps){
    return <DraggableModal show={show} onHide={onHide} headerNode="Вы уверены?" centered>
        <Modal.Body>
            При изменении формулы произойдет перерасчёт фактических значений!
        </Modal.Body>
        <Modal.Footer>
            <div className="d-flex justify-content-end align-items-center gap-3">
                <Button variant='outline-danger' onClick={onHide}>Отмена</Button>
                <Button variant='outline-primary' onClick={onAccept}>Сохранить</Button>
            </div>
        </Modal.Footer>
    </DraggableModal>
}
